import { render, staticRenderFns } from "./addNode.vue?vue&type=template&id=4c06b812&"
import script from "./addNode.vue?vue&type=script&lang=js&"
export * from "./addNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports